export class VersionModel {
    constructor(data) {
        if (!data || !data.version) return;
        //The version is something like v3.0.12
        this.version = `${data.version}`;
        //substring(0-1) removes the 'v' and then splits by dot characters
        let splicedVersionString = this.version.substring(1).split(".");
        let concatedVersionString =
            splicedVersionString[0] + splicedVersionString[1] + splicedVersionString[2];

        this.versionCodeString = concatedVersionString;
        this.versionCode = Number(concatedVersionString);
    }

    versionCodeString = "";
    versionCode = 0;
    version = "";
}



// WEBPACK FOOTER //
// ./src/helper/version/Version.model.js